// src/App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "leaflet/dist/leaflet.css";

// 🔓 Public
import Login from "./components/Login";
import VendorRegister from "./components/VendorRegister";
import SupplierRegister from "./components/SupplierRegister";
import ContractorRegister from "./components/ContractorRegister";
import EmployeeRegister from "./components/EmployeeRegister";
import ForgotPassword from './components/ForgotPassword';
import AccountDeletionRequestPage from "./components/AccountDeletionRequestPage";
import PrivacyPolicyPage from "./components/PrivacyPolicyPage";

// 👨‍💼 Admin
import AdminMainLayout from "./components/AdminMainLayout";
import AdminDashboard from "./components/AdminDashboard";
import AdminVendorList from "./components/AdminVendorList";
import AdminSupplierList from "./components/AdminSupplierList";
import AdminEmployeeList from "./components/AdminEmployeeList";
import AdminEmployeeDetail from "./components/AdminEmployeeDetail";
import AssignVendors from "./components/AssignVendors";
import AdminAttendancePage from "./components/AdminAttendancePage";
import AdminLiveTrackingPage from "./components/AdminLiveTrackingPage";
import AdminEmployeeTrackingHistoryPage from "./components/AdminEmployeeTrackingHistoryPage";
import AdminEmployeeAttendanceReport from "./components/AdminEmployeeAttendanceReport";
import CertificatePage from "./components/CertificatePage";
import RequirementForm from "./components/RequirementForm";
import EmployeeIdCard from "./components/EmployeeIDCardPage";
import AdminVendorRequirements from "./components/AdminVendorRequirements";
import AdminRequirementDispatches from "./components/AdminRequirementDispatches";
import AdminSupplierDispatches from "./components/AdminSupplierDispatches";
import AdminSupplierCertificatePage from "./components/AdminSupplierCertificatePage";
import Reports from "./components/AdminReports";
import AdminWorkflowMap from "./components/AdminWorkflowMap";
import AdminVendorView from "./components/AdminVendorView";
import AdminSupplierView from "./components/AdminSupplierView";
import AdminSupplierPoView from "./components/AdminSupplierPoView";
import AdminMetaLeads from "./components/AdminMetaLeads";
import AdminWhatsAppSettings from "./components/AdminWhatsAppSettings";
import AdminWhatsAppHistory from "./components/AdminWhatsAppHistory";
// ✅ NEW: Admin profile page import
import AdminProfile from "./components/AdminProfile";
import AdminDepartmentsRoles from "./components/AdminDepartmentsRoles";
import AdminProductCatalog from "./components/AdminProductCatalog";
import AdminWorktimeSummary from "./components/AdminWorktimeSummary";
import AdminNotifications from "./components/AdminNotifications";
import AdminPayrollApprovals from "./components/AdminPayrollApprovals";
import AdminPayoutDesk from "./components/AdminPayoutDesk";
import AdminContractorList from "./components/AdminContractorList";
import AdminContractorRates from "./components/AdminContractorRates";
import AdminContractorView from "./components/AdminContractorView";
import AdminVendorSecurity from "./components/AdminVendorSecurity";


// 🧾 Vendor
import VendorMainLayout from "./components/VendorMainLayout";
import VendorOverview from "./components/VendorOverview";
import VendorProfileForm from "./components/VendorProfileForm";
import VendorCertificate from "./components/VendorCertificate";
import VendorRequirementHistory from "./components/VendorRequirementHistory";
import VendorDispatches from "./components/VendorDispatches";
import VendorNotifications from "./components/VendorNotifications";
import ProductGalleryPage from "./components/ProductGalleryPage";

// 🧾 Supplier
import SupplierMainLayout from "./components/SupplierMainLayout";
import SupplierDashboard from "./components/SupplierDashboard";
import SupplierPoView from "./components/SupplierPoView";
import SupplierProfileForm from "./components/SupplierProfileForm";
import SupplierDispatchForm from "./components/SupplierDispatchForm";
import SupplierDispatchHistory from "./components/SupplierDispatchHistory";
import SupplierCertificate from "./components/SupplierCertificate";
import GovernmentRegister from "./components/GovernmentRegister";
import GovernmentMainLayout from "./components/GovernmentMainLayout";
import GovernmentPortal from "./components/GovernmentPortal";
import GovernmentThumbHistory from "./components/GovernmentThumbHistory";
import GovernmentProfile from "./components/GovernmentProfile";
import GovernmentVendorHistory from "./components/GovernmentVendorHistory";
import VendorThumbLedger from "./components/VendorThumbLedger";
import AdminGovernmentPortal from "./components/AdminGovernmentPortal";

// 👷 Contractor
import ContractorMainLayout from "./components/ContractorMainLayout";
import ContractorDashboard from "./components/ContractorDashboard";
import ContractorProfileForm from "./components/ContractorProfileForm";
import ContractorWorkEntryForm from "./components/ContractorWorkEntryForm";
import ContractorWorkHistory from "./components/ContractorWorkHistory";
import ContractorWorkApprovalPage from "./components/ContractorWorkApprovalPage";
import ContractorPaymentHistoryPage from "./components/ContractorPaymentHistoryPage";

// 👷‍♂️ Employee
import EmployeeMainLayout from "./components/EmployeeMainLayout";
import EmployeeDashboard from "./components/EmployeeDashboard";
import AttendanceForm from "./components/AttendanceForm";
import AssignedVendors from "./components/AssignedVendors";
import AssignedSuppliers from "./components/AssignedSuppliers";
import AssignedRequirements from "./components/AssignedRequirements";
import EmployeeReport from "./components/EmployeeReport";
import EmployeeIDCardPage from "./components/EmployeeIDCardPage";
import EmployeeProfile from "./components/EmployeeProfile";
import EmployeeAgreement from "./components/EmployeeAgreement";
import EmployeeNotifications from "./components/EmployeeNotifications";
import EmployeeReportHistory from "./components/EmployeeReportHistory";
import EmployeeSalaryPage from "./components/EmployeeSalaryPage";
import SalesDashboard from "./components/SalesDashboard";
import PhonePePaymentPage from "./components/PhonePePaymentPage";
import PhonePeTransactionsPage from "./components/PhonePeTransactionsPage";
import {
  AccountsDashboard,
  AccountsInvoices,
  AccountsParties,
  AccountsExpenses,
  AccountsVendorBills,
  AccountsQualityPayments,
  AccountsVendorIncomingPayments,
  AccountsSupplierPayables,
  AccountsPayments,
  AccountsPayroll,
  AccountsTaxes,
  AccountsReports,
  AccountsAuditLogs,
  AccountsWorktime,
} from "./components/EmployeeAccountsPages";
import * as DepartmentPages from "./components/EmployeeDepartmentPages";
import AccountsGovernmentSecurity from "./components/accounts/AccountsGovernmentSecurity";
import HrDashboard from "./components/hr/HrDashboard";
import PlantDepartmentDashboard from "./components/departments/PlantDepartmentDashboard";
import PurchaseDepartmentDashboard from "./components/departments/PurchaseDepartmentDashboard";
import QualityDepartmentDashboard from "./components/departments/QualityDepartmentDashboard";
import PlantSupplierQualityWorkflow from "./components/departments/PlantSupplierQualityWorkflow";




// 🔒 Private Route
import PrivateRoute from "./components/PrivateRoute";
import AdminIDCardPage from "./components/AdminIDCardPage";
import { initTheme } from "./utils/theme";

import GuardDashboard from "./components/GuardDashboard";
import GuardAttendance from "./components/GuardAttendance";
import GuardVehicleLookup from "./components/GuardVehicleLookup";
import GuardVehicleLogs from "./components/GuardVehicleLogs";
import GuardAttendanceHistory from "./components/GuardAttendanceHistory";
import PaymentHistoryPage from "./components/PaymentHistoryPage";
import LotsuChatbot from "./components/LotsuChatbot";

const hasAny = (perms = [], list = []) =>
  list.some((p) => Array.isArray(perms) && perms.includes(p));

const getEmployeeDefaultPath = ({ permissions = [], departmentName = "", roleName = "" }) => {
  const perms = Array.isArray(permissions) ? permissions : [];
  const deptRole = `${departmentName} ${roleName}`.toLowerCase();

  const isGuard =
    perms.includes("guard:access") ||
    perms.some((p) => typeof p === "string" && p.startsWith("security:"));
  if (isGuard) return "/employee/guard/dashboard";

  const isSales = /(sales|marketing)/.test(deptRole) || hasAny(perms, [
    "leads:view",
    "leads:edit",
    "deals:view",
    "deals:edit",
    "reports:sales:view",
    "sales:targets:manage",
  ]);
  if (isSales) return "/employee/sales/dashboard";

  const isFinance = hasAny(perms, [
    "finance:invoice:create",
    "finance:invoice:approve",
    "finance:expense:create",
    "finance:expense:approve",
    "finance:vendor-bill:upload",
    "finance:vendor-bill:approve",
    "finance:payments:update",
    "finance:payments:approve",
    "finance:payments:release",
    "finance:gst:view",
    "finance:tds:view",
    "finance:reports:view",
    "finance:audit-logs:view",
    "salary:process",
    "salary:approve",
  ]);
  if (isFinance) return "/employee/accounts";

  const isPurchase = /(purchase|procurement)/.test(deptRole) || hasAny(perms, [
    "purchase:request:create",
    "purchase:order:create",
    "vendor-master:edit",
    "purchase:rate-comparison:view",
    "material:availability:view",
  ]);
  if (isPurchase) return "/employee/purchase/dashboard";

  const isQuality = /(quality|qa|qc)/.test(deptRole) || hasAny(perms, [
    "quality:check:view",
    "quality:check:create",
    "quality:reject:create",
    "quality:approve",
    "quality:reports:view",
  ]);
  if (isQuality) return "/employee/qa/dashboard";

  const isPlant = /(plant|production)/.test(deptRole) || hasAny(perms, [
    "production:plan",
    "production:report",
    "stock:consumption:view",
    "maintenance:log",
    "wastage:view",
    "plant:shift:manage",
    "plant:overtime:approve",
    "plant:utilization:view",
    "plant:breakdown:view",
    "plant:maintenance:approve",
    "plant:quality:review",
    "plant:inventory:alert",
    "plant:material-movement:approve",
    "plant:contractor-work:approve",
    "plant:safety:manage",
    "plant:compliance:manage",
    "plant:coordination:manage",
    "plant:reports:manage",
  ]);
  if (isPlant) return "/employee/plant/dashboard";

  const isHr = /hr/.test(deptRole) || hasAny(perms, [
    "employees:view",
    "leave:view",
    "performance:view",
    "hr:onboarding:manage",
    "hr:recruitment:manage",
  ]);
  if (isHr) return "/employee/hr/dashboard";

  return "/employee/dashboard";
};

const getStoredSessionRedirect = () => {
  if (typeof window === "undefined") return "/login";

  const token = localStorage.getItem("token");
  if (!token) return "/login";

  let role = String(localStorage.getItem("role") || "").toLowerCase();
  let user = {};
  let permissions = [];

  try {
    user = JSON.parse(localStorage.getItem("user") || "{}");
  } catch (_err) {
    user = {};
  }
  try {
    permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
  } catch (_err) {
    permissions = [];
  }

  if (!role) {
    role = String(user?.role || "").toLowerCase();
  }
  if (!Array.isArray(permissions) || permissions.length === 0) {
    permissions = Array.isArray(user?.permissions) ? user.permissions : [];
  }

  if (role === "admin") return "/admin";
  if (role === "vendor") return "/vendor";
  if (role === "supplier") return "/supplier";
  if (role === "contractor") return "/contractor";
  if (role === "government") return "/government";
  if (role === "employee") {
    return getEmployeeDefaultPath({
      permissions,
      departmentName: user?.department?.name || "",
      roleName: user?.employeeRole?.name || "",
    });
  }
  if (role === "guard") return "/employee/guard/dashboard";
  return "/login";
};

function App() {
  useEffect(() => {
    initTheme();
  }, []);

  return (
    <Router>
      <Routes>
        {/* 🔓 Public Routes */}
        <Route path="/" element={<Navigate to={getStoredSessionRedirect()} replace />} />
        <Route
          path="/login"
          element={
            localStorage.getItem("token") ? (
              <Navigate to={getStoredSessionRedirect()} replace />
            ) : (
              <Login />
            )
          }
        />
        <Route path="/register/vendor" element={<VendorRegister />} />
        <Route path="/register/supplier" element={<SupplierRegister />} />
        <Route path="/register/contractor" element={<ContractorRegister />} />
        <Route path="/register/government" element={<GovernmentRegister />} />
        <Route path="/register/employee" element={<EmployeeRegister />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/request-account-deletion" element={<AccountDeletionRequestPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route
          path="/payments/phonepe"
          element={
            <PrivateRoute roles={["admin", "vendor", "supplier", "contractor", "employee"]}>
              <PhonePePaymentPage />
            </PrivateRoute>
          }
        />


      {/* 👨‍💼 Admin Panel */}
<Route
  path="/admin"
  element={
    <PrivateRoute roles={["admin"]}>
      <AdminMainLayout />
    </PrivateRoute>
  }
>
  <Route index element={<AdminDashboard />} />
  <Route path="vendors" element={<AdminVendorList />} />
  <Route path="vendor-security" element={<AdminVendorSecurity />} />
  <Route path="suppliers" element={<AdminSupplierList />} />
  <Route path="contractors" element={<AdminContractorList />} />
  <Route path="contractor-rates" element={<AdminContractorRates />} />
  <Route path="/admin/contractors/:id/view" element={<AdminContractorView />} />
  <Route path="contractors/:id/account" element={<AdminContractorView />} />
  <Route path="employees" element={<AdminEmployeeList />} />
  <Route path="employees/:id/account" element={<AdminEmployeeDetail />} />
  <Route path="assign-vendors" element={<AssignVendors />} />
  <Route path="attendance-summary" element={<AdminAttendancePage />} />
  <Route path="attendance-live" element={<AdminLiveTrackingPage />} />
  <Route path="employee-tracking-history" element={<AdminEmployeeTrackingHistoryPage />} />
  <Route path="attendance-report" element={<AdminEmployeeAttendanceReport />} />
  <Route path="worktime-summary" element={<AdminWorktimeSummary />} />
  <Route path="certificates" element={<CertificatePage />} />
  <Route path="requirements" element={<RequirementForm />} />
  <Route path="idcards" element={<AdminIDCardPage />} />
  <Route path="vendor-requirements" element={<AdminVendorRequirements />} />
  <Route path="requirement-dispatches" element={<AdminRequirementDispatches />} />
  <Route path="supplier-dispatches" element={<AdminSupplierDispatches />} />
  <Route path="government-portal" element={<AdminGovernmentPortal />} />
  <Route path="supplier-certificates" element={<AdminSupplierCertificatePage />} />
  <Route path="products" element={<AdminProductCatalog />} />
  <Route path="reports" element={<Reports />} />   {/* ✅ New Reports Route */}
  <Route path="workflow-map" element={<AdminWorkflowMap />} />
  <Route path="meta-leads" element={<AdminMetaLeads />} />
  <Route path="whatsapp" element={<AdminWhatsAppSettings />} />
  <Route path="whatsapp/history" element={<AdminWhatsAppHistory />} />
  <Route path="notifications" element={<AdminNotifications />} />
  <Route path="payroll" element={<AdminPayrollApprovals />} />
  <Route path="payouts" element={<AdminPayoutDesk />} />
  <Route
    path="phonepe-transactions"
    element={<PhonePeTransactionsPage endpoint="/admin/phonepe-transactions" title="PhonePe Transactions (Admin)" />}
  />
  <Route path="payments/phonepe" element={<PhonePePaymentPage />} />
  <Route
    path="payment-history"
    element={
      <PaymentHistoryPage
        endpoint="/admin/payment-history"
        title="Admin Payment History"
        createEndpoint="/payments/phonepe/create"
        statusEndpoint="/payments/phonepe/status"
        adminVendorLedgerBase="/admin/vendors"
      />
    }
  />
  <Route path="departments-roles" element={<AdminDepartmentsRoles />} />
  <Route path="/admin/vendors/:id/view" element={<AdminVendorView />} />
  <Route path="vendors/:id/account" element={<AdminVendorView />} />
  <Route path="/admin/suppliers/:id/view" element={<AdminSupplierView />} />
  <Route path="suppliers/:id/account" element={<AdminSupplierView />} />
  <Route path="/admin/suppliers/:id/po" element={<AdminSupplierPoView />} />
  
          <Route path="profile" element={<AdminProfile />} />
</Route>


        {/* 🧾 Vendor Panel */}
        <Route
          path="/vendor"
          element={
            <PrivateRoute roles={["vendor"]}>
              <VendorMainLayout />
            </PrivateRoute>
          }
        >
          <Route index element={<Navigate to="overview" replace />} />
          <Route path="overview" element={<VendorOverview />} />
          <Route path="profile" element={<VendorProfileForm />} />
          <Route path="requirement" element={<RequirementForm />} />
          <Route path="certificate" element={<VendorCertificate />} />
          <Route path="requirement/history" element={<VendorRequirementHistory />} />
          <Route path="dispatches" element={<VendorDispatches />} />
          <Route
            path="gallery"
            element={
              <ProductGalleryPage
                endpoint="/vendor/products"
                title="Product Gallery"
                subtitle="Admin-uploaded product images with packaging-wise filter"
              />
            }
          />
          <Route
            path="payment-history"
            element={
              <PaymentHistoryPage
                endpoint="/vendor/payment-history"
                title="Vendor Payment History"
                createEndpoint="/vendor/payments/phonepe/create"
                statusEndpoint="/vendor/payments/phonepe/status"
                ledgerEndpoint="/vendor/payment-history/ledger"
              />
            }
          />
          <Route path="notifications" element={<VendorNotifications />} />
          <Route path="thumb-ledger" element={<VendorThumbLedger />} />
        </Route>

        {/* 🧾 Supplier Panel */}
        <Route
          path="/supplier"
          element={
            <PrivateRoute roles={["supplier"]}>
              <SupplierMainLayout />
            </PrivateRoute>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<SupplierDashboard />} />
          <Route path="profile" element={<SupplierProfileForm />} />
          <Route path="dispatch/create" element={<SupplierDispatchForm />} />
          <Route path="dispatch/edit/:id" element={<SupplierDispatchForm />} />
          <Route path="dispatch/history" element={<SupplierDispatchHistory />} />
          <Route path="po-details" element={<SupplierPoView />} />
          <Route
            path="payment-history"
            element={
              <PaymentHistoryPage
                endpoint="/supplier/payment-history"
                title="Supplier Payment History"
                createEndpoint="/supplier/payments/phonepe/create"
                statusEndpoint="/supplier/payments/phonepe/status"
                ledgerEndpoint="/supplier/payment-history/ledger"
              />
            }
          />
          <Route path="certificate" element={<SupplierCertificate />} />
        </Route>

        <Route
          path="/government"
          element={
            <PrivateRoute roles={["government"]}>
              <GovernmentMainLayout />
            </PrivateRoute>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<GovernmentPortal />} />
          <Route path="thumb-history" element={<GovernmentThumbHistory />} />
          <Route path="profile" element={<GovernmentProfile />} />
          <Route path="vendors/:vendorId/history" element={<GovernmentVendorHistory />} />
        </Route>

        {/* 👷 Contractor Panel */}
        <Route
          path="/contractor"
          element={
            <PrivateRoute roles={["contractor"]}>
              <ContractorMainLayout />
            </PrivateRoute>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<ContractorDashboard />} />
          <Route path="profile" element={<ContractorProfileForm />} />
          <Route path="work-entry" element={<ContractorWorkEntryForm />} />
          <Route path="work-history" element={<ContractorWorkHistory />} />
          <Route path="payment-history" element={<ContractorPaymentHistoryPage />} />
        </Route>

        {/* 👷‍♂️ Employee Panel */}
        <Route
          path="/employee"
          element={
            <PrivateRoute roles={["employee"]}>
              <EmployeeMainLayout />
            </PrivateRoute>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<EmployeeDashboard />} />
          <Route path="attendance" element={<AttendanceForm />} />
          <Route path="idcard" element={<EmployeeIdCard />} />
          <Route path="my-vendors" element={<AssignedVendors />} />
          <Route path="my-suppliers" element={<AssignedSuppliers />} />
          <Route
            path="my-vendors/:id"
            element={
              <AdminVendorView
                endpointBase="/employee/vendors"
                endpointSuffix="/full"
                listPath="/employee/my-vendors"
                showAdminActions={false}
                showHistory
                showLedger
                historyEndpoint={`/employee/vendors/:id/history`}
              />
            }
          />
          <Route path="my-requirements" element={<AssignedRequirements />} />
          <Route
            path="my-suppliers/:id"
            element={
              <AdminSupplierView
                endpointBase="/employee/suppliers"
                endpointSuffix="/full"
                listPath="/employee/my-suppliers"
                showAdminActions={false}
                showHistory={false}
                showLedger={false}
              />
            }
          />
          <Route
            path="suppliers/:id"
            element={
              <AdminSupplierView
                endpointBase="/employee/suppliers"
                endpointSuffix="/full"
                listPath="/employee/dashboard"
                showAdminActions={false}
                showHistory={false}
                showLedger={false}
              />
            }
          />
          <Route
            path="gallery"
            element={
              <ProductGalleryPage
                endpoint="/employee/products"
                title="Product Gallery"
                subtitle="Packaging filter select karke relevant product packets dekhiye"
              />
            }
          />
          <Route path="reports" element={<EmployeeReport />} />
          <Route path="my-idcard" element={<EmployeeIDCardPage />} />
          <Route path="profile" element={<EmployeeProfile />} />
          <Route path="notifications" element={<EmployeeNotifications />} />
          <Route path="agreement" element={<EmployeeAgreement />} />
          <Route path="reports/history" element={<EmployeeReportHistory />} />
          <Route
            path="payment-history"
            element={
              <PaymentHistoryPage
                endpoint="/employee/payment-history"
                title="Employee Payment History"
                createEndpoint="/employee/payments/phonepe/create"
                statusEndpoint="/employee/payments/phonepe/status"
              />
            }
          />
          <Route path="salary" element={<EmployeeSalaryPage />} />
          <Route
            path="accounts/phonepe-transactions"
            element={<PhonePeTransactionsPage endpoint="/employee/accounts/phonepe-transactions" title="PhonePe Transactions (Accounts)" />}
          />
          <Route path="accounts" element={<AccountsDashboard />} />
          <Route path="sales/dashboard" element={<SalesDashboard />} />
          <Route path="accounts/parties" element={<AccountsParties />} />
          <Route path="accounts/invoices" element={<AccountsInvoices />} />
          <Route path="accounts/expenses" element={<AccountsExpenses />} />
          <Route path="accounts/vendor-bills" element={<AccountsVendorBills />} />
          <Route path="accounts/quality-payments" element={<AccountsQualityPayments />} />
          <Route path="accounts/vendor-incoming-payments" element={<AccountsVendorIncomingPayments />} />
          <Route path="accounts/supplier-payables" element={<AccountsSupplierPayables />} />
          <Route path="accounts/payments" element={<AccountsPayments />} />
          <Route path="accounts/government-security" element={<AccountsGovernmentSecurity />} />
          <Route path="accounts/payroll" element={<AccountsPayroll />} />
          <Route path="accounts/worktime" element={<AccountsWorktime />} />
          <Route
            path="accounts/contractor-work-entries"
            element={
              <ContractorWorkApprovalPage
                title="Contractor Payment Desk"
                subtitle="Plant approved contractor daily work entries, queries, clarifications and payment processing."
                endpoint="/employee/accounts/contractor-work-entries"
                canQuery
                canProcessPayment
                reviewScope="accounts"
                infoMessage="Yahan sirf Plant Manager approved entries dikhengi. Accounts yahi se query raise karke ya payment process karke contractor payout complete karega."
              />
            }
          />
          <Route path="accounts/taxes" element={<AccountsTaxes />} />
          <Route path="accounts/reports" element={<AccountsReports />} />
          <Route path="accounts/audit-logs" element={<AccountsAuditLogs />} />
          <Route path="hr/dashboard" element={<HrDashboard />} />
          <Route path="hr/employees" element={<DepartmentPages.HrEmployees />} />
          <Route path="hr/leave-requests" element={<DepartmentPages.HrLeaveRequests />} />
          <Route path="hr/attendance-approvals" element={<DepartmentPages.HrAttendanceApprovals />} />
          <Route path="hr/performance-reviews" element={<DepartmentPages.HrPerformanceReviews />} />
          <Route path="hr/reports" element={<DepartmentPages.HrReports />} />
          <Route path="hr/onboarding" element={<DepartmentPages.HrOnboarding />} />
          <Route path="hr/offboarding" element={<DepartmentPages.HrOffboarding />} />
          <Route path="hr/recruitment" element={<DepartmentPages.HrRecruitment />} />
          <Route path="hr/policies" element={<DepartmentPages.HrPolicies />} />
          <Route path="hr/training" element={<DepartmentPages.HrTraining />} />
          <Route path="hr/grievance" element={<DepartmentPages.HrGrievance />} />
          <Route path="hr/vacancies" element={<DepartmentPages.HrVacancies />} />
          <Route path="hr/interviews" element={<DepartmentPages.HrInterviews />} />
          <Route path="hr/offer-letters" element={<DepartmentPages.HrOfferLetters />} />
          <Route path="hr/holidays" element={<DepartmentPages.HrHolidays />} />
          <Route path="hr/attendance-rules" element={<DepartmentPages.HrAttendanceRules />} />
          <Route path="hr/salary-structures" element={<DepartmentPages.HrSalaryStructures />} />
          <Route path="hr/payslips" element={<DepartmentPages.HrPayslips />} />
          <Route path="hr/resignations" element={<DepartmentPages.HrResignations />} />
          <Route path="hr/exit-interviews" element={<DepartmentPages.HrExitInterviews />} />
          <Route path="hr/letters" element={<DepartmentPages.HrLetters />} />
          <Route path="hr/documents" element={<DepartmentPages.HrDocuments />} />
          <Route path="hr/payroll-runs" element={<DepartmentPages.HrPayrollRuns />} />
          <Route
            path="hr/contractor-work-entries"
            element={
              <ContractorWorkApprovalPage
                title="Contractor Work Entries"
                subtitle="Plant approved contractor daily work entries with query and clarification flow."
                endpoint="/employee/hr/contractor-work-entries"
                canQuery
                reviewScope="hr"
                infoMessage="HR ko agar plant approval me issue lage to yahi se query raise kare. Contractor aur Plant Manager dono clarification de sakte hain."
              />
            }
          />
          <Route path="hr/deduction-rules" element={<DepartmentPages.HrDeductionRules />} />
          <Route path="hr/candidates" element={<DepartmentPages.HrCandidateProfiles />} />
          <Route path="hr/appraisals" element={<DepartmentPages.HrAppraisals />} />
          <Route path="live-tracking" element={<AdminLiveTrackingPage />} />
          <Route path="sales/leads" element={<DepartmentPages.SalesLeads />} />
          <Route path="sales/meta-leads" element={<DepartmentPages.SalesMetaLeads />} />
          <Route path="sales/deals" element={<DepartmentPages.SalesDeals />} />
          <Route path="sales/targets" element={<DepartmentPages.SalesTargets />} />
          <Route path="sales/pricing-approvals" element={<DepartmentPages.SalesPricingApprovals />} />
          <Route path="sales/reports" element={<DepartmentPages.SalesReports />} />
          <Route path="plant/dashboard" element={<PlantDepartmentDashboard />} />
          <Route path="plant/production-plans" element={<DepartmentPages.PlantProductionPlans />} />
          <Route path="plant/production-reports" element={<DepartmentPages.PlantProductionReports />} />
          <Route path="plant/maintenance-logs" element={<DepartmentPages.PlantMaintenanceLogs />} />
          <Route path="plant/wastage-logs" element={<DepartmentPages.PlantWastageLogs />} />
          <Route path="plant/stock-consumption" element={<DepartmentPages.PlantStockConsumption />} />
          <Route path="plant/shift-plans" element={<DepartmentPages.PlantShiftPlans />} />
          <Route path="plant/overtime-approvals" element={<DepartmentPages.PlantOvertimeApprovals />} />
          <Route path="plant/utilization" element={<DepartmentPages.PlantUtilization />} />
          <Route path="plant/breakdowns" element={<DepartmentPages.PlantBreakdowns />} />
          <Route path="plant/maintenance-schedules" element={<DepartmentPages.PlantMaintenanceSchedules />} />
          <Route path="plant/supplier-quality-workflow" element={<PlantSupplierQualityWorkflow />} />
          <Route path="plant/quality-reviews" element={<DepartmentPages.PlantQualityReviews />} />
          <Route path="plant/wastage-analysis" element={<DepartmentPages.PlantWastageAnalysis />} />
          <Route path="plant/material-movement" element={<DepartmentPages.PlantMaterialMovement />} />
          <Route path="plant/inventory-alerts" element={<DepartmentPages.PlantInventoryAlerts />} />
          <Route path="plant/safety-incidents" element={<DepartmentPages.PlantSafetyIncidents />} />
          <Route path="plant/compliance-audits" element={<DepartmentPages.PlantComplianceAudits />} />
          <Route path="plant/coordination-logs" element={<DepartmentPages.PlantCoordinationLogs />} />
          <Route path="plant/performance-reports" element={<DepartmentPages.PlantPerformanceReports />} />
          <Route
            path="plant/contractor-work-entries"
            element={
              <ContractorWorkApprovalPage
                title="Contractor Work Approval"
                subtitle="Verify contractor daily work, approve/reject, and respond to Accounts/HR queries."
                endpoint="/employee/plant/contractor-work-entries"
                canApprove
                canClarify
                infoMessage="Contractor ka saved daily work pehle yahan aayega. Plant Manager approve karega to entry Accounts aur HR dono ko visible ho jayegi. Query aaye to yahi se clarity bhi submit hogi."
              />
            }
          />
          <Route path="purchase/dashboard" element={<PurchaseDepartmentDashboard />} />
          <Route path="purchase/requests" element={<DepartmentPages.PurchaseRequests />} />
          <Route path="purchase/orders" element={<DepartmentPages.PurchaseOrders />} />
          <Route path="purchase/vendor-master" element={<DepartmentPages.PurchaseVendorMaster />} />
          <Route path="purchase/rate-comparisons" element={<DepartmentPages.PurchaseRateComparisons />} />
          <Route path="purchase/material-availability" element={<DepartmentPages.PurchaseMaterialAvailability />} />
          <Route path="inventory/stock-ledger" element={<DepartmentPages.InventoryStockLedger />} />
          <Route path="inventory/grn" element={<DepartmentPages.InventoryGRN />} />
          <Route path="inventory/issue-return" element={<DepartmentPages.InventoryIssueReturn />} />
          <Route path="inventory/adjustments" element={<DepartmentPages.InventoryAdjustments />} />
          <Route path="inventory/reports" element={<DepartmentPages.InventoryReports />} />
          <Route path="logistics/shipments" element={<DepartmentPages.LogisticsShipments />} />
          <Route path="logistics/dispatch-requests" element={<DepartmentPages.LogisticsPlanning />} />
          <Route path="logistics/packing-lists" element={<DepartmentPages.LogisticsPacking />} />
          <Route path="logistics/transport" element={<DepartmentPages.LogisticsTransport />} />
          <Route path="logistics/dispatch-notes" element={<DepartmentPages.LogisticsDispatchProcess />} />
          <Route path="logistics/tracking" element={<DepartmentPages.LogisticsTracking />} />
          <Route path="logistics/returns" element={<DepartmentPages.LogisticsReturns />} />
          <Route path="logistics/reports" element={<DepartmentPages.LogisticsReports />} />
          <Route path="qa/dashboard" element={<QualityDepartmentDashboard />} />
          <Route path="qa/checks" element={<DepartmentPages.QAChecks />} />
          <Route path="qa/rejections" element={<DepartmentPages.QARejections />} />
          <Route path="qa/approvals" element={<DepartmentPages.QAApprovals />} />
          <Route path="qa/reports" element={<DepartmentPages.QAReports />} />
          <Route path="guard/dashboard" element={<GuardDashboard />} />
          <Route path="guard/attendance" element={<GuardAttendance />} />
          <Route path="guard/attendance/history" element={<GuardAttendanceHistory />} />
          <Route path="guard/vehicles" element={<GuardVehicleLookup />} />
          <Route path="guard/logs" element={<GuardVehicleLogs />} />
          <Route path="guard/profile" element={<EmployeeProfile />} />

        </Route>

        {/* 🛡️ Guard compatibility routes */}
        <Route path="/guard" element={<Navigate to="/employee/guard/dashboard" replace />} />
        <Route path="/guard/dashboard" element={<Navigate to="/employee/guard/dashboard" replace />} />
        <Route path="/guard/attendance" element={<Navigate to="/employee/guard/attendance" replace />} />
        <Route path="/guard/attendance/history" element={<Navigate to="/employee/guard/attendance/history" replace />} />
        <Route path="/guard/vehicles" element={<Navigate to="/employee/guard/vehicles" replace />} />
        <Route path="/guard/logs" element={<Navigate to="/employee/guard/logs" replace />} />
        <Route path="/guard/profile" element={<Navigate to="/employee/profile" replace />} />
        <Route path="/quality" element={<Navigate to="/employee/qa/dashboard" replace />} />
        <Route path="/quality/dashboard" element={<Navigate to="/employee/qa/dashboard" replace />} />
        <Route path="/quality/checks" element={<Navigate to="/employee/qa/checks" replace />} />
        <Route path="/quality/rejections" element={<Navigate to="/employee/qa/rejections" replace />} />
        <Route path="/quality/approvals" element={<Navigate to="/employee/qa/approvals" replace />} />
        <Route path="/quality/reports" element={<Navigate to="/employee/qa/reports" replace />} />

        {/* 🚫 404 Fallback */}
        <Route path="*" element={<h2 className="text-center mt-5">404 - Page Not Found</h2>} />
      </Routes>
      <LotsuChatbot />
    </Router>
  );
}

export default App;
